module.exports = __webpack_public_path__ + "static/media/IconRulingActive.953018f0.svg";